import React from 'react';
import { describeCron, nextRunFromCron } from '../../../lib/formatters/cron';
import { format } from 'date-fns';

// Compact "what runs next" summary strip (T7.8).
function NextRunSummary({ jobs = [] }) {
  const upcoming = jobs
    .map((job) => ({ job, next: nextRunFromCron(job.cron) }))
    .filter((entry) => entry.next)
    .sort((a, b) => a.next - b.next)
    .slice(0, 3);

  if (!upcoming.length) {
    return null;
  }

  return (
    <div className="next-run-strip">
      {upcoming.map(({ job, next }) => (
        <div className="next-run-card" key={job.id}>
          <span>{job.agentName}</span>
          <strong>{format(next, 'EEE HH:mm')}</strong>
          <em>{describeCron(job.cron)}</em>
        </div>
      ))}
    </div>
  );
}

export default NextRunSummary;
